import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { SidebarService, ModalService } from '@ibe/services/ui';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import * as fromStore from '../../../../store';
import * as ConfirmModalActions from '@ibe/store/actions/confirm-modal.actions';
import { takeWhile } from 'rxjs/operators';
import { INDRAAddExtraModalComponent } from '@ibe.components/shared/add-extra-modal/add-extra-modal.indra.component';
import { INDRALoginModalComponent } from '@ibe.components/shared/login-modal/login-modal.indra.component';
import { TRANSLATION_ANCILLARIES_TYPE, USE_MILES_EXTRAS_PRIORITY } from '@ibe.config';
import { BookedTrip } from '@ibe/models';
import { INDRAPrice } from '@ibe.models/booking.fare.indra.model.lib';
import { PaymentService } from '@ibe.components/shared/payment/payment.service';
import { INDRAFlightPriceService } from '@ibe.services/flight-price.indra.service';
import { INDRABFMDataStorageService } from '@ibe.services/bfm-data-storage.indra.service';
import { INDRAMilesService } from '@ibe.services/miles.indra.service';
import { INDRAStorageService } from '@ibe.services/storage.indra.service';
import { INDRACurrencyService } from '@ibe.services/currency.indra.service';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';

@Component({
	selector: 'app-use-miles-info',
	templateUrl: './use-miles-info.indra.component.html',
	styleUrls: ['./use-miles-info.component.scss']
})
export class INDRAUseMilesInfoComponent implements OnInit, OnDestroy {

	// User info
	userInfo$: Observable<any> = this.store.select(fromStore.getUserInfo);
	hasLogin: boolean = false;
	userMiles;
	
	// Corp
	// isCorporate$: Observable<boolean> = this.store.select(fromStore.getIsCorporate);
	// isCorporate: boolean;
	// promotype: string;
	// promocoin: string;

	currency: string;
	flightTotalPrice;
	flightBasePrice: number;

	conversionRates = [];
	maxConversion: number = 0;
	maxConvertedCash: number = 0;
	maxToUseConversion: number = 0;
	maxToUseConvertedCash: number = 0;
	
	bookedTrip$: Observable<BookedTrip> = this.store.select(fromStore.getSelectedBookedTrip);
	booked_trip;
	milesDiscount$: Observable<INDRAPrice> = this.store.select(fromStore.getMilesBarDiscountInformationMiles);
	milesDiscount: INDRAPrice;
	promoMiles = { value: 0, discount: 0 };
	minMilesNeeded;
	milesNotEnoughForMaxFlightDiscount: boolean = true;
	milesNotEnoughForMinFlightDiscount: boolean = true;
	// private hasChanges$: Observable<any> = combineLatest([this.user$, this.milesSpended$]);

	bookAwardFlights$: Observable<boolean> = this.store.select(fromStore.getFlightsFilterBookAwardFlights);
	bookAwardFlights: boolean;

	ancillaryList = [];
	ancillaryListCanPay = [];
	ancillaryListCannotPay = [];
	hasExtras: boolean = false;
	extrasPriority = USE_MILES_EXTRAS_PRIORITY;
	suggestions = [];
	suggestionsToLoad = 2;
	flightDetails = [];
	ancillariesFromFlights = [];

	isPayment: boolean = false;
	isAlive: boolean = true;

	constructor(
		private dataStorage: INDRABFMDataStorageService,
		private storageService: INDRAStorageService,
		private store: Store<fromStore.State>,
		private modalService: ModalService,
		private milesService: INDRAMilesService,
		private currencyService: INDRACurrencyService,
		private ibeAdminService: INDRAIbeAdminService,
		private bfmStorage: INDRABFMDataStorageService,
		private router: Router,
		private sidebarService: SidebarService,
		private flightPriceService: INDRAFlightPriceService) {

		this.currency = this.currencyService.INDRA_getCurrencySymbol().unit;
		
		this.bookedTrip$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				if (value) {
					this.booked_trip = value;
				}
			});

		if (this.sidebarService.getSidebarParameters().length) {
			this.milesService.flightDetails = this.sidebarService.getSidebarParameters();
		}

		this.INDRA_getAncillariesFromFlights();

		this.bookAwardFlights$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				this.bookAwardFlights = value;
			});

		this.milesDiscount$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				this.milesDiscount = value;
			});

		this.userInfo$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(userInfo => {
				// this.milesService.INDRA_getMilesConversionRates();
				if (userInfo) {
					this.hasLogin = true;
					this.userMiles = userInfo['currentPoints'] ? userInfo['currentPoints'] : 0;
				} else {
					this.hasLogin = false;
					this.userMiles = 0;
				}
			});

		this.milesService.conversionRates$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(conversionRates => {
				this.conversionRates = conversionRates;
				if (conversionRates.length) {
					this.promoMiles.discount = this.milesDiscount.cash;
					this.promoMiles.value = this.milesDiscount.miles;

					this.flightTotalPrice = (this.bfmStorage.INDRA_getActiveBookedTrip().data.fare.flightPrice.totalPrice.price).toFixed(2);

					const rates = conversionRates.filter(rate => rate.valueCash);
					// if there are no rates use initial mgp1 as max
					const max = rates.length > 0 ? rates[rates.length - 1] : { miles: this.milesDiscount.miles, valueCash: this.milesDiscount.cash}; 
					this.maxConversion = max.miles;
					this.maxConvertedCash = max.valueCash;

					const ratesMaxToUse = rates.length > 0 ? rates.filter(rate => rate.miles <= this.userMiles) : [{ miles: 0, valueCash: 0}];
					const maxToUse = ratesMaxToUse[ratesMaxToUse.length - 1];
					this.maxToUseConversion = maxToUse.miles;
					this.maxToUseConvertedCash = maxToUse.valueCash;

					this.milesNotEnoughForMaxFlightDiscount = this.userMiles < this.maxConversion ? true : false;
					this.milesNotEnoughForMinFlightDiscount = this.userMiles ? this.userMiles < this.promoMiles.value ? true : false : true;
				}
			});

		this.isPayment = this.router.url.includes('/booking/payment');

		/* note: from post-sprint 8 client code merge
		this.isCorporate$.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				this.isCorporate = value;
				if (value === true) {
					this.promotype = 'balance';
					this.promocoin = '€';
				} else {
					this.promotype = 'miles';
					this.promocoin = 'M';
				}
			});
		*/
	}

	ngOnInit() {
		this.INDRA_getBundleListWithPoints();
		this.INDRA_getAddedAncillaries();
	}

	ngOnDestroy(): void {
		this.isAlive = false;
	}

	INDRA_getAncillariesFromFlights() {
		this.flightDetails = this.milesService.flightDetails;
		this.ancillariesFromFlights = [];
		this.flightDetails.forEach(flight => {
			if (flight.ancillaries && flight.ancillaries.length) {
				this.ancillariesFromFlights = this.ancillariesFromFlights.concat(flight.ancillaries);
			}
		});
	}

	INDRA_getBundleListWithPoints() {
		const bundleList = [];
		if (this.dataStorage.activeBooking['ancillaries-data'] && this.dataStorage.activeBooking['ancillaries-data'].bundleList) {
			this.dataStorage.activeBooking['ancillaries-data'].bundleList.forEach(bundle => {
				if (bundle.ancillaryList && bundle.ancillaryList.length && bundle.ancillaryList[0].catalog) {
					bundle.ancillaryList[0].catalog.forEach(catalog => {
						if (catalog.passengers) {
							catalog.passengers.forEach(passenger => {
								if (passenger.codeList[0].points) {
									const extra = this.ancillariesFromFlights.find(x => x.type === bundle.ancillaryList[0].type);
									const cat: any = {
										id: extra ? extra.id : '',
										name: extra ? extra.name : '',
										type: bundle.ancillaryList[0].type,
										flightId: catalog.flightId,
										paxId: passenger.paxId,
										points: passenger.codeList[0].points
									};
									bundleList.push(cat);
								}
							});
						}
					});
				}
			});

			const suggestions: any[] = [];
			const sortedBundlePrio: any[] = bundleList.slice().sort(bundle => this.extrasPriority.includes(bundle.type) ? -1 : 1);
			sortedBundlePrio.forEach(bundle => { if (!suggestions.find(x => x.type === bundle.type)) suggestions.push(bundle); });
			this.suggestions = suggestions.slice(0, this.suggestionsToLoad);
		}
	}

	INDRA_getAddedAncillaries() {
		this.ancillaryList = [];
		const ancillaryList = this.storageService.get('INDRAAncillariesShoppingCartService.shoppingCart');
		if (ancillaryList != null && ancillaryList.length != 0) {
			const ancillaryArr = [];
			for (const i in ancillaryList.itemsAdded) {
				let found = false;
				if (ancillaryArr.length == 0) {
					ancillaryArr.push(Object.assign({}, ancillaryList.itemsAdded[i], { count: 1 }));
					found = true;
				} else {
					for (const x in ancillaryArr) {
						if (ancillaryArr[x].type == ancillaryList.itemsAdded[i].type) {
							ancillaryArr[x].count = ancillaryArr[x].count + 1;
							ancillaryArr[x].points = ancillaryArr[x].points + ancillaryList.itemsAdded[i].points;
							// tslint:disable-next-line:radix
							ancillaryArr[x].price = parseInt(ancillaryArr[x].price) + parseInt(ancillaryList.itemsAdded[i].price);
							found = true;
							break;
						}
					}
				}

				if (!found) {
					ancillaryArr.push(Object.assign({}, ancillaryList.itemsAdded[i], { count: 1 }));
				}
			}

			this.ancillaryList = ancillaryArr;
			const sortedAddedAncillaries: any[] = ancillaryArr.slice().sort((a, b) => a.points - b.points);
			const sortedSuggestions: any[] = this.suggestions.slice().sort((a, b) => a.points - b.points);
			this.minMilesNeeded = sortedAddedAncillaries.length ? sortedAddedAncillaries[0].points : sortedSuggestions.length ? sortedSuggestions[0].points : 0;

			if (this.hasLogin) { this.INDRA_generateAncillariesToPay(); }
		}
		this.hasExtras = this.ancillaryList.length ? true : false;
	}

	INDRA_generateAncillariesToPay() {
		let maxMiles = this.userMiles;
		if (this.bookAwardFlights) {
			const flightMilesPrice = this.flightPriceService.INDRA_computeBookingPointsTotal(this.booked_trip.flights, this.booked_trip.booking_type, true);
			maxMiles = this.userMiles - flightMilesPrice;
			this.minMilesNeeded += flightMilesPrice;
		} else if (this.promoMiles.value) {
			maxMiles = this.userMiles - this.promoMiles.value;
			this.minMilesNeeded += this.promoMiles.value;
		}

		this.ancillaryList.forEach(extra => {
			let totalToPay = 0;
			this.ancillaryListCanPay.forEach(x => totalToPay += x.points);
			totalToPay + extra.points <= maxMiles ? this.ancillaryListCanPay.push(extra) : this.ancillaryListCannotPay.push(extra);
		});
	}

	INDRA_getExtraName(type: string) {
		return this.ibeAdminService.getTranslationValue(TRANSLATION_ANCILLARIES_TYPE + type);
	}

	INDRA_getDiscountedFlightPrice() {
		const toDeduct = this.milesNotEnoughForMinFlightDiscount ? this.maxConvertedCash : this.maxToUseConvertedCash;
		return (this.flightTotalPrice - toDeduct).toFixed(2);
	}

	INDRA_separator(index: number) {
		let separator = '';
		if (this.extrasPriority.length > 1) {
			separator = index < this.extrasPriority.length - 2 ? ', ' : index === this.extrasPriority.length - 2 ? ' or ' : '';
		}

		return separator;
	}

	INDRA_handleLogin() {
		this.modalService.assignComponent(INDRALoginModalComponent);
		this.modalService.open();
	}

	INDRA_handleNewAccount() {
		this.sidebarService.openSidebar(['sign-up']);
	}

	INDRA_handleExtraSidebar(extra) {
		this.store.dispatch(new ConfirmModalActions.PutTitle(extra.name));
		this.modalService.assignComponent(INDRAAddExtraModalComponent, { feature: extra.id, flightDetails: this.flightDetails });
		this.modalService.open();
	}


	INDRA_getMilesTitle() {
		if (this.hasLogin) {
			if (this.INDRA_canPayUsingMiles()) {
				return `${this.INDRA_getTranslation('extrasSidebar.useMilesInfo.text.useYour')} ` + this.currencyService.INDRA_formatMiles(this.userMiles) + ` ${this.INDRA_getTranslation('extrasSidebar.useMilesInfo.text.milesTo')}`;
			} else {
				return `${this.INDRA_getTranslation('extrasSidebar.useMilesInfo.text.youHave')} ` + this.currencyService.INDRA_formatMiles(this.userMiles) + ` ${this.INDRA_getTranslation('extrasSidebar.useMilesInfo.text.miles')}.<br> ${this.INDRA_getTranslation('extrasSidebar.useMilesInfo.text.keepFlyingToEarn')}`;
			}
		} else {
			return `${this.INDRA_getTranslation('extrasSidebar.useMilesInfo.text.youCanUseYourMiles')}`;
		}
	}

	INDRA_handleClose() {
		this.sidebarService.closeSidebar();
	}

	INDRA_canAdd(){
		return this.hasLogin && !this.hasExtras && this.userMiles >= this.minMilesNeeded && !this.isPayment;
	}

	INDRA_cannotAdd() {
		const validator = this.promoMiles.discount ? this.milesNotEnoughForMinFlightDiscount : this.userMiles < this.minMilesNeeded;
		return ( (!this.hasLogin && !this.hasExtras) || (this.hasLogin && !this.hasExtras && validator) ) && !this.isPayment;
	}

	INDRA_cannotBuyExtrasAdded() {
		const validator = this.promoMiles.discount ? this.milesNotEnoughForMinFlightDiscount : this.userMiles < this.minMilesNeeded;
		return this.hasExtras && (!this.hasLogin || (this.hasLogin && validator));
	}

	INDRA_cannotBuyMaxFlightDiscount() {
		return this.conversionRates.length && !this.bookAwardFlights && this.milesNotEnoughForMaxFlightDiscount && !this.milesNotEnoughForMinFlightDiscount;
	}

	INDRA_canPayUsingMiles() {
		return this.userMiles >= this.minMilesNeeded || (!this.milesNotEnoughForMinFlightDiscount && !this.bookAwardFlights);
	}

	INDRA_getTranslation(key: string): string {
		return this.ibeAdminService.getTranslationValue(key);
	}
	
	/* note: from post-sprint 8 client code merge
	TAP_getPromoNomenclature(): string {
		return this.promotype;
	}

	TAP_getPromoCoin(): string {
		return this.promocoin;
	}

	TAP_getBannerImage() {
		if (!this.isCorporate) {
			return 'assets/images/banner_milesgo.svg';
		} else {
			return 'assets/images/banner_corporate-promo.png';
		}
	}
	*/

}
